import templateService from './templateService'

export default templateService
